<template>
  <div class="container">
    <div class="list-container f-column-b">
      <div class="list-header">
        <ul v-if="threeList.length"  class="f-start-c flex-1">
          <li v-for="(nt,index) in threeList" :key="nt.code"  :class="{active: index === activeIndex}" @click="changeType(nt.id,index)">{{ nt.name }}</li>
        </ul> 
        <h3 class="title" v-else>{{ isSearch ? "搜索结果" : cateInfo.name }}</h3>
      </div>
      <div class="info-list f-column-b">
        <ul v-if="list.length">
          <li v-for="(item, index) in list" :key="index" class="info-item" @click="viewItem(item)">
            <span class="point" />
            <span class="flex-1 text-cut ml-20 title-txt">{{ item.title }}</span>
            <span class="ml-40 color-999">{{ item.releaseTime }}</span>
          </li>
        </ul>
        <no-data v-else />
      </div>
    </div>
    <info-pagination
      :total="total"
      :current-page.sync="curPage"
      :page-size="pageSize"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import infoApi from "@/api/information"
import { parseTime } from "@/filters";
import NoData from "@/components/NoData.vue";
import InfoPagination from "@/components/InfoPagination.vue";

export default {
  name: "InfoList",
  components: {
    InfoPagination,
    NoData
  },
  props: {
    cateInfo: {
      type: Object,
      default: () => {}
    },
    threeList: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      title: "",
      curPage: 1,
      pageSize: 15,
      total: 0,
      list: [], 
      activeIndex: 0
    };
  },
  // 监听属性 类似于data概念
  computed: {
    ...mapGetters(["activeMenuId"]),
    isSearch() {
      return this.$route.query && Object.prototype.hasOwnProperty.call(this.$route.query, "title")
    }
  },
  watch: {
    cateInfo() {
      this.title = ""
      this.getList("0")
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.title = this.$route.query.title || ""
    this.getList()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
  },
  // 方法集合
  methods: {
    changeType(id,index){
      this.activeIndex = index;
      this.getList(id)
    },
    // 获取列表
    getList(id) {
      let columnId = ''
      if(this.threeList.length > 0){
        columnId = id ?? this.threeList[0].id 
      }else{
        columnId = this.cateInfo.id
      }
      infoApi.page({
        pageNo: this.curPage,
        pageSize: this.pageSize,
        columnId,
        title: this.title
      }).then(res => {
        if (res.code === 0) {
          const data = res.data || {}
          const list = data.list || []
          this.total = data.total
          list.forEach(item => {
            item.releaseTime = parseTime(item.releaseTime, "{y}-{m}-{d}")
          })
          this.list = data.list
        }
      })
    },
    // 翻页
    handleCurrentChange(val) {
      this.curPage = val
      this.getList()
    },
    // 行点击
    viewItem(item) {
      this.$router.push({
        name: "infoDetail",
        query: {
          id: item.id
        }
      })
    }
  }
};
</script>

<style scoped lang="scss">
  .list-container{
    border: 1px solid #ddd;
    padding: 0 20px;
    min-height: 800px;
    .list-header{
      height: 60px;
      line-height: 60px;
      border-bottom: 2px solid #ddd;
      .title{
        font-size: 24px;
        color: $--color-primary;
        position: relative;
        &::after{
          content: '';
          width: 96px;
          height: 2px;
          background-color: $--color-primary;
          position: absolute;
          bottom: 0;
          left: 0;
        }
      }
      ul>li{
        cursor: pointer;
        color: #000;
        font-size: 24px;
        position: relative;
        margin: 0 20px 0 0;
        &.active{
          color: $--color-primary;
          font-weight: bold;
          &::after{
            content: '';
            width: 46px;
            height: 2px;
            background-color: $--color-primary;
            position: absolute;
            bottom: 0;
            left: 0;
          }
        }
        &:hover{
          color: $--color-primary;
        }
      }
    }
    .info-list{
      flex: 1;
      min-height: 0;
      padding-bottom: 10px;
      .info-item{
        height: 50px;
        display: flex;
        align-items: center;
        cursor: pointer;
        border-bottom: 1px solid #ddd;
        &:hover{
          .title-txt{
            color: $--color-primary;
          }
        }
        &:last-child{
          border: none;
        }
        .point{
          width: 5px;
          height: 5px;
          background-color: $--color-primary;
        }
      }
    }
  }
</style>
